import React, { useState } from 'react';
import {MapRef, Marker} from "react-map-gl"
import { toAbsoluteUrl } from '../../../../../../_metronic/helpers';
import { Plants } from '../../../../../@types/plants';
import useSize from '../../../../../hooks/useSize';

type Props = {
    plant: Plants,
    myPlantSelected: string
    setMyPlant: React.Dispatch<React.SetStateAction<string>>,
    setShowCreateAppModal: React.Dispatch<React.SetStateAction<boolean>>
    mapRef: React.RefObject<MapRef>
}

export function MarkerMaps({
    plant,
    myPlantSelected,
    setMyPlant,
    setShowCreateAppModal,
    mapRef
}: Props) {
    const {width} = useSize();

    function corrigirCoordenada(coordenadaString: string) {
        if (coordenadaString.includes(',')) {
            return coordenadaString.replace(',', '.');
        } else {
            return coordenadaString;
        }
    }

    const [myPosition] = useState<{ lat: number | null, lng: number | null }>(() => {
        const defaultLat = null;
        const defaultLng = null;

        let lat: number | null = defaultLat;
        let lng: number | null = defaultLng;

        if (plant.plantLat && plant.plantLat !== null && plant.plantLat !== undefined) {
            const latValue = Number(corrigirCoordenada(plant.plantLat.toString()));
            if (!Number.isNaN(latValue) && latValue >= -90 && latValue <= 90) {
                lat = latValue;
            }
        }

        if (plant.plantLon && plant.plantLon !== null && plant.plantLon !== undefined) {
            const lngValue = Number(corrigirCoordenada(plant.plantLon.toString()));
            if (!Number.isNaN(lngValue) && lngValue >= -180 && lngValue <= 180) {
                lng = lngValue;
            }
        }

        return { lat, lng };
    });

    return (
        myPosition.lat && myPosition.lng ? (
            <Marker
                key={plant.plantId}
                latitude={myPosition.lat}
                longitude={myPosition.lng}
                draggable
                style={{
                    zIndex: myPlantSelected === plant.id ? 9999 : 1,
                }}
                onClick={() => {
                    mapRef.current?.flyTo({
                        center: [myPosition.lng || -47.8828, myPosition.lat || -15.7939],
                        zoom: 12,
                        essential: true,
                    })
                    setMyPlant(plant.id)
                    setShowCreateAppModal(true)
                }}
            >
                {myPlantSelected && myPlantSelected === plant.id ? (
                    <div
                    onClick={() => {
                        setMyPlant(plant.id)
                        setShowCreateAppModal(true)
                    }}
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '0.5rem',
                        // transform: myPlantSelected === plant.id ? "scale(1.2)" : "scale(1)",
                        transition: "transform 0.2s ease",
                    }}
                    >
                    <div className='symbol bg-primary symbol-circle'>
                        <span className={`symbol symbol-40px text-primary fs-4 fw-bolder p-2`}>
                        <img
                            src={toAbsoluteUrl(`/media/imgs/plant-${
                            plant.status !== null
                                ? plant.status === 0
                                ? "sucess"
                                : plant.status === 1
                                ? "danger"
                                : plant.status === 2
                                ? "warning"
                                : plant.status === 7 || plant.status === 3
                                ? "info"
                                : "indentify"
                                : "indentify"
                            }.png`)}
                            alt=''
                        />
                        </span>
                    </div>
                    <span className={`badge badge-light fw-bolder text-dark fs-8 px-2 py-1 ms-2`}>
                        {plant && plant.name ? plant.name : ""}
                    </span>
                    </div>
                ) : (
                    <i
                    title={`${plant.name}`}
                    onClick={() => {
                        setMyPlant(plant.id)
                        setShowCreateAppModal(true)
                    }}
                    >
                    <div className={`symbol ${width < 1200 ? "symbol-40px" : "symbol-50px"} me-5`}>
                        <img
                        src={toAbsoluteUrl(`/media/imgs/plant-${
                            plant.status !== null
                            ? plant.status === 0
                                ? "sucess"
                                : plant.status === 1
                                ? "danger"
                                : plant.status === 2
                                ? "warning"
                                : plant.status === 7 || plant.status === 3
                                ? "info"
                                : "indentify"
                            : "indentify"
                        }.png`)}
                        alt=''
                        />
                    </div>
                    </i>
                )}
            </Marker>
        ) : null
    )
}